export enum FlyoutType
{
    home,
    search,
    contactInformation,
    notifications,
    settings,
    profile
}